// extracted by mini-css-extract-plugin
module.exports = {"main":"ReasonTile_main_2aRwC","mobile":"ReasonTile_mobile_25MkT","image":"ReasonTile_image_2QUJ4","text":"ReasonTile_text_1NNd0"};